import React, { useState } from 'react';
import { Dropdown, DropdownToggle } from 'reactstrap';
import { AiOutlineEye } from "react-icons/ai";

const BookingDetails = ({ onBookingDetails, onBookingHistory, color,className }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggleDetailsDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    return (
        <div className="d-flex">
            <Dropdown isOpen={dropdownOpen} toggle={toggleDetailsDropdown}>
                <DropdownToggle
                    caret
                    className={className}
                    style={{ fontSize: "11px", padding: "0px 5px" }}
                >
                    <AiOutlineEye style={{ fontSize: '16px', color: color }} onClick={onBookingDetails} />
                </DropdownToggle>
            </Dropdown>
        </div>
    );
};

export default BookingDetails;